import Entity from "./Entity";

export default class MapBundle extends Entity {
    constructor(data) {
        super(data);
    }

    get id() {
        return this.get("id");
    }

    set id(value) {
        this.set("id", value);
    }

    get applicationId() {
        return this.get("applicationId");
    }

    set applicationId(value) {
        this.set("applicationId", value);
    }

    get title() {
        return this.get("title");
    }

    set title(value) {
        this.set("title", value);
    }

    get description() {
        return this.get("description");
    }

    set description(value) {
        this.set("description", value);
    }

    get accessCodes() {
        return this.get("accessCodes");
    }

    set accessCodes(value) {
        this.set("accessCodes", value);
    }

    get mainAccessCode() {
        const accessCodes = this.accessCodes;
        if (accessCodes) {
            if (accessCodes.length >= 2) {
                return accessCodes[1];
            } else if (accessCodes.length == 1) {
                return accessCodes[0];
            }
        }
        return null;
    }

    set mainAccessCode(value) {
        if (value != null) {
            this.set("accessCodes", [ "ondago123", value ])
        } else {
            this.set("accessCodes", null);
        }
    }

    get centerPoint() {
        return this.get("centerPoint");
    }

    set centerPoint(value) {
        this.set("centerPoint", value)
    }

    get emergencyActionAvailable() {
        return this.get("emergencyActionAvailable");
    }

    set emergencyActionAvailable(value) {
        this.set("emergencyActionAvailable", value);
    }

    get terrainReportActionAvailable() {
        return this.get("terrainReportActionAvailable");
    }

    set terrainReportActionAvailable(value) {
        this.set("terrainReportActionAvailable", value);
    }

    get mapObjectListMode() {
        return this.get("mapObjectListMode");
    }

    set mapObjectListMode(value) {
        this.set("mapObjectListMode", value);
    }

    get useNewMapUI() {
        return this.get("useNewMapUI");
    }

    set useNewMapUI(value) {
        this.set("useNewMapUI", value);
    }

    get supportPartialUpdate() {
        return this.get("supportPartialUpdate");
    }

    set supportPartialUpdate(value) {
        this.set("supportPartialUpdate", value);
    }

    get publisherName() {
        return this.get("publisherName");
    }

    set publisherName(value) {
        this.set("publisherName", value);
    }

    get publisherContact() {
        return this.get("publisherContact");
    }

    set publisherContact(value) {
        this.set("publisherContact", value);
    }

    get publisherContactPhone() {
        return this.get("publisherContactPhone");
    }

    set publisherContactPhone(value) {
        this.set("publisherContactPhone", value);
    }

    get numberOfKilometers() {
        return this.get("numberOfKilometers");
    }

    set numberOfKilometers(value) {
        const valueAsInt = parseInt(value);
        this.set("numberOfKilometers", valueAsInt);
    }

    get filterFields() {
        return this.get("filterFields");
    }

    set filterFields(value) {
        this.set("filterFields", value);
    }

    get dogsAllowedComment() {
        return this.get("dogsAllowedComment");
    }

    set dogsAllowedComment(value) {
        this.set("dogsAllowedComment", value);
    }

    get accessibleComment() {
        return this.get("accessibleComment");
    }

    set accessibleComment(value) {
        this.set("accessibleComment", value);
    }

    // get accessible() {
    //     return this.get("accessible");
    // }

    // set accessible(value) {
    //     this.set("accessible", value);
    // }

    // get dogAllowed() {
    //     return this.get("dogAllowed");
    // }

    // set dogAllowed(value) {
    //     this.set("dogAllowed", value);
    // }

    get location() {
        return this.get("location");
    }

    set location(value) {
        this.set("location", value);
    }

    get tags() {
        return this.get("tags");
    }

    set tags(value) {
        this.set("tags", value);
    }

    getId() {
        return this.get("id");
    }

    getTitle() {
        return this.get("title");
    }
}